import { Inject, Injectable } from '@angular/core';

import { LoggerService } from '../../../frontend-logger/src/lib/logger.service';
import { STORAGE_TOKEN } from './index';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

  constructor(
    private readonly logger: LoggerService,
    @Inject(STORAGE_TOKEN) private readonly storage: Storage,
  ) {}

  remove(...keys: string[]) {
    for (let i = 0; i < keys.length; i++) {
      this.storage.removeItem(keys[i]);
    }
  }

  set<T extends any>(key: string, value: T): void {
    try {
      this.storage.setItem(key, JSON.stringify(value));
    } catch (err) {
      this.logger.error(err);
    }
  }

  get<T>(key: string): T | null {
    try {
      return JSON.parse(this.storage.getItem(key));
    } catch (err) {
      this.logger.error(err);
      console.error(err);
      return null;
    }
  }

  clear() {
    this.storage.clear();
  }
}
